import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_food_snacks: FaireCategoryEntity = {
  token: "cat_food-snacks",
  type: "category",
  name: "Snacks",
  level: 2,
  parentToken: "cat_food-drink",
  href: "/category/snacks",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
